import { useState, useEffect } from "react";
import { useCustomizationStore } from "features/ManageWebpage/modules/Customizations/store/useCustomizationStore";
import { useWebpageSectionChange } from "features/ManageWebpage/modules/Customizations/store/useWebpageSectionChange";
import { CUSTOMIZATION_SECTIONKEYS } from "features/ManageWebpage/modules/Customizations/common/utils/Customization.constants";
import { getRegexObjectFromString } from "ui/pages/TemplatePreview/utils";
import { SUBDOMAIN_VALIDATION_REGEX_PATTERN } from "constants/regExpPatterns";
import { SUBDOMAIN_VALIDATION_ERROR_MSG } from "constants/displayStrings";

const WEBSITE_ADDRESS_BASE_DOMAIN = "exlyapp.com";

export const useWebsiteAddress = () => {
  const sectionConfig = useCustomizationStore((state) => state.sectionConfig);
  const sectionValue =
    sectionConfig[CUSTOMIZATION_SECTIONKEYS.WEBSITE_ADDRESS]?.value;

  const [websiteAddress, setWebsiteAddress] = useState(sectionValue || "");
  const [error, setError] = useState("");
  const { handleSectionChange } = useWebpageSectionChange();

  useEffect(() => {
    if (sectionValue !== undefined && sectionValue !== null) {
      setWebsiteAddress(sectionValue);
    }
  }, [sectionValue]);

  const handleChange = (e) => {
    setWebsiteAddress(e.target.value);
    if (error) setError("");
  };

  const handleBlur = () => {
    const isValidSubDomain = getRegexObjectFromString(
      SUBDOMAIN_VALIDATION_REGEX_PATTERN,
      "g"
    ).test(websiteAddress);

    if (!isValidSubDomain) {
      setError(SUBDOMAIN_VALIDATION_ERROR_MSG);
      return;
    }

    const payload = {
      feature_key: CUSTOMIZATION_SECTIONKEYS.WEBSITE_ADDRESS,
      feature_value: websiteAddress,
    };
    handleSectionChange({ payload });
  };

  const fullUrl = websiteAddress
    ? `https://${websiteAddress}.${WEBSITE_ADDRESS_BASE_DOMAIN}`
    : "";

  const handleOpenWebsite = () => {
    if (!fullUrl) return;
    const urlWithProtocol = fullUrl.startsWith("http")
      ? fullUrl
      : `https://${fullUrl}`;
    window.open(urlWithProtocol, "_blank", "noopener,noreferrer");
  };

  return {
    websiteAddress,
    handleChange,
    handleBlur,
    fullUrl,
    handleOpenWebsite,
    error,
  };
};
